import { Injectable, EventEmitter } from '@angular/core';
import { AppTypesFormState } from '../../models/LocalServiceModels/AppTypesFormState';

@Injectable({
  providedIn: 'root'
})
export class AppTypeFormService {

  public AppTypesFormState:AppTypesFormState;

  public AppTypeFormChange:EventEmitter<AppTypesFormState> = new EventEmitter<AppTypesFormState>();

  constructor() {
    this.AppTypeFormChange.subscribe((state:AppTypesFormState)=> {
      this.AppTypesFormState = state;
    })
   }

}
